module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_6.f7c6f447.jpg";